/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Tman, Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import {Button } from 'react-bootstrap';
import InputText from '../../../../shared/AOForm/components/InputText/InputText';
import Select from '../../../../shared/AOForm/components/Select';
import ContentOnly from '../ContentOnly/index.js';
import DividingLine from "../DividingLine/index";

export default class MailAddressGroup extends React.Component {
  constructor(props) {
    super(props);

    [
      'addAction',
      'deleteAction',
    ].forEach((fn) => this[fn] = this[fn].bind(this));
  }

  addAction = (event)=> {
    /*
    * callback the onClick action for the "Add" button.
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const { onAddAction } = this.props;
    onAddAction && onAddAction();

    return false;
  };

  deleteAction = (event) => {
    /*
    * callback the onClick action for the "Delete" button.
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const { onDelAction } = this.props;
    onDelAction && onDelAction(event.target);

    return false;
  };

  render() {
    const {
      content,
      itemArray,
      onChangeAction,
      addBtnText,
      removeBtnText,
      repeatMax,
      handleBlurAction
    } = this.props;

    const canDel = itemArray.length>1 ? '' : 'disabled';
    const addBtnStatus = (repeatMax && repeatMax <= itemArray.length) ? 'none': '';

    return (
      <div className="dynamic-group mail-address-group clearfix">
        { content && <ContentOnly content={ content } /> }

        {
          itemArray && itemArray.map((item, index) => {
            return (
              <div className="multi-group-item clearfix" key={`mailAddressGroup_${index}`}>
                  <InputText
                    content={ item.street }
                    handleTextChange={ onChangeAction }
                    parentIndex={ index }
                    dataIndex={ 0 }
                    handleBlurAction={handleBlurAction}
                  />
                  <InputText
                    content={ item.city }
                    handleTextChange={ onChangeAction }
                    parentIndex={ index }
                    dataIndex={ 1 }
                    handleBlurAction={handleBlurAction}
                  />
                  <Select
                    content={ item.country }
                    onChangeAction={ onChangeAction }
                    defaultValue={ item.country.defaultValue }
                    validationState={ item.country.isError ? 'error' : null }
                    hasDelBtn={ false }
                    parentIndex={ index }
                    dataIndex={ 2 }
                    disabled={ item.country.disabled }
                  />
                  <InputText
                    content={ item.postCode }
                    handleTextChange={ onChangeAction }
                    parentIndex={ index }
                    dataIndex={ 3 }
                    handleBlurAction={handleBlurAction}
                  />

                  <div className="group-del-btn clearfix">
                      <a
                        data-key={ removeBtnText.dataKey }
                        className={`delete-btn ${canDel}`}
                        onClick={ this.deleteAction }
                        data-index={ index }
                        style={{display: itemArray.length>1 ? '' : 'none'}}
                      >
                        { removeBtnText.text }
                      </a>
                  </div>

                  <DividingLine />
              </div>
            )
          })
        }
          <div className="add-btn-row" style={{display: addBtnStatus}}>
              <Button onClick={ this.addAction } disabled={false} data-key={ addBtnText.dataKey }>
                  <i aria-hidden={true} className="icon icon-add">{}</i>
                { addBtnText.text }
              </Button>
          </div>
      </div>
    )
  }
};

MailAddressGroup.propTypes = {
  content: PropTypes.object,
  itemArray: PropTypes.array.isRequired,
  onChangeAction: PropTypes.func,
  onInputChangeAction: PropTypes.func,
  onDelAction: PropTypes.func,
  onAddAction: PropTypes.func,
  addBtnText: PropTypes.object,
  removeBtnText: PropTypes.object,
  repeatMax: PropTypes.number,
  handleBlurAction:PropTypes.func
};

MailAddressGroup.defaultProps = {
  itemArray: [],
  disabled: false
};


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/MailAddressGroup/index.js